
import Headroom from 'headroom.js'
import { mapGetters, mapMutations } from 'vuex'
import btnIcon from '@/components/common/buttons/btn-icon'
import * as utils from '@/lib/utils.js'
export default {
  name: 'HeaderAppMobile',
  components: { btnIcon },
  data() {
    return {
      openMenu: false,
      search: '',
      showSearch: false,
      selectedButton: {},
      innerMenu: false,
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'locale']),
    navBar() {
      return this.$store.state.layoutData?.content?.navbar.components || null
    },
  },
  mounted() {
    const headerElement = document.getElementById('mobile-header')
    const headroom = new Headroom(headerElement, { offset: 100 })
    headroom.init()
  },
  methods: {
    openSearchModal() {
      this.$store.commit('changeShowSearch', true)
    },
    goHome() {
      window.location.href = this.localePath('/')
    },
    getSubmenuOptions: utils.getSubmenuOptions,
    getSubmenuFilterKey: utils.getSubmenuFilterKey,
    onOpenCart() {
      this.$store.commit('cart/updateCurrentAddedItems', 0)
    },
    onLeave() {
      this.$refs.dropdown.visible = false
    },
    ...mapMutations(['changeLocale']),
    changeLang(value) {
      this.$cookies.set('locale', value, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7,
      })
      location.reload()
    },
    changeInner(item) {
      this.innerMenu = true
      this.selectedButton = item
    },
    openMenuAction() {
      if (this.openMenu) {
        this.openMenu = false
        document.body.style.overflowY = 'auto'
      } else {
        this.openMenu = true
        document.body.style.overflowY = 'hidden'
      }
    },
  },
}
